export const cohortTableConf = [
  {
    field: 'time',
    title: 'Time'
  },
  {
    field: 'cost',
    title: 'Cost'
  },
  {
    field: 'initial',
    title: 'Initial'
  }
];
